import { render, staticRenderFns } from "./ProfileButton.vue?vue&type=template&id=91d3d9fa"
import script from "./ProfileButton.vue?vue&type=script&lang=ts"
export * from "./ProfileButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports